import Cookies                 from "js-cookie";
import { useEffect, useState } from "react";

import { DEFAULT_ERROR_MSG } from "_common/string_config";
import toast                 from "_common/toast";
import { useSetWebviewURL }  from "_jotai/index";

import { useGetLoggedIn } from "./auth";

export const useShopWebview =  ( { productId } ) => {

	const [ queryParams, setQueryParams ] = useState ( "" );

	// const [ shopEnv, setShopEnv ] = useState ( "https://d1vvuebj5u2s41.cloudfront.net" );
	const [ shopEnv, setShopEnv ] = useState ( process.env.APP_ENV === "prod" ? "https://shop.rooter.gg" : "https://d1vvuebj5u2s41.cloudfront.net" );
	const isLoggedIn              = useGetLoggedIn ();
	const setWebviewURL           = useSetWebviewURL ();

	async function getAuth () {
		try {
			const cookie = Cookies.get ( "user_auth" );

			const jsonValue = JSON.parse ( decodeURIComponent ( cookie ) );

			return jsonValue;
		} catch ( error ) {
			// console.log ( "=============  error:", error );
			toast.error ( DEFAULT_ERROR_MSG );
		}
	}

	const productURL = `${ shopEnv }/product/${ productId }${ queryParams ? `?${ queryParams }` : "" } `;

	function updateShopLink ( input ) {
		switch ( input ) {
			case "prod":
				setShopEnv ( "https://shop.rooter.gg" );
				break;

			case "localhost":
				setShopEnv ( "http://localhost:3000" );
				break;

			case "stage":
				setShopEnv ( "https://d1vvuebj5u2s41.cloudfront.net" );
				break;

			default:
				break;
		}
	}

	async function createWebviewURL () {
		try {
			const auth = await getAuth ();

			auth.deviceType = "web";
			auth.deviceId   = "some-random-id";
			auth.appVersion = "1.0.5";
			auth.platform   = "rooterWeb";

			delete auth.userRoles;
			delete auth.isVerified;
			delete auth.locale;
			delete auth.isNew;

			const params = new URLSearchParams ( auth ).toString ();

			setQueryParams ( params );

		} catch ( error ) {
			// console.log ( "=============  error:", error );
			toast.error ( DEFAULT_ERROR_MSG );
		}
	}

	useEffect ( () => {
		if ( isLoggedIn )
			createWebviewURL ();
		else
			setQueryParams ( "" );
	}, [ isLoggedIn ] );

	useEffect ( () => {
		setWebviewURL ( `${ shopEnv }${ queryParams ? `/?${ queryParams }` : "" }` );
	}, [ shopEnv, queryParams ] );

	return {
		queryParams,
		shopEnv,
		productURL,
		updateShopLink
	};
};
